var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NationalSystem',{attrs:{"title":"GP (MPL Demographics)","filter":r => r.notebook === 'Demo-GP',"scan-results":_vm.scanResults}},[_vm._v(" A single GP demographic file is pushed to NIIAS for the whole of Wales each day. This file was not received (so far) on this day. ")])
}
var staticRenderFns = []

export { render, staticRenderFns }